module.exports = __webpack_public_path__ + "img/manifest.d0af9d41.svg";